// @flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import {
    customEditableFieldFactory,
    InactiveFieldComponent
} from 'common/components/core/common/CustomEditableField';
import { ButtonTypes, ButtonWithPopover } from 'common/components/core/button';
import { PopoverTriggerEnum } from 'common/components/core/popover/popOverFactory';
import Icon from 'common/components/core/icon';
import defaultTheme from './PlanNote.scss';
import DataUtils from 'common/utils/DataUtils';

const EditableInputFieldWithDeleteButton = customEditableFieldFactory({
    InactiveFieldComponent: props => {
        const {
            onDelete,
            theme,
            deleteDisabled,
            deleteButtonPopover,
            ...others
        } = props;

        return (
            <>
                <InactiveFieldComponent
                    {...others}
                    className={theme.inactiveField}
                    theme={theme}
                />
                <ButtonWithPopover
                    ripple={false}
                    buttonType={ButtonTypes.Icon}
                    icon="delete-bin"
                    onClick={onDelete}
                    theme={theme}
                    className={theme.deleteBtn}
                    disabled={deleteDisabled}
                    triggerPopoverOn={PopoverTriggerEnum.Hover}
                    popOverContent={deleteButtonPopover}
                />
            </>
        );
    }
});

type Props = {
    t: Function,
    index: number,
    note: string,
    theme: Function,
    key: number,
    hideNote: Function,
    saveNote: Function,
    deleteNote: Function,
    onClick: Function,
    selected: boolean,
    editDisabled?: boolean,
    deleteDisabled?: boolean,
    deleteButtonPopover?: React.Node
};

class PlanNote extends React.PureComponent<Props> {
    deleteNote = e => {
        e.preventDefault();
        const { deleteNote, index } = this.props;
        return deleteNote && deleteNote(index);
    };

    saveNote = note => {
        const { saveNote, deleteNote, index } = this.props;
        if (!DataUtils.isEmpty(note)) {
            saveNote && saveNote(note, index);
        } else {
            deleteNote && deleteNote(index);
        }
        return Promise.resolve();
    };

    onReject = () => {
        const { index, deleteNote } = this.props;
        if (!this.props.note) {
            return deleteNote && deleteNote(index);
        }
    };

    render() {
        const {
            theme,
            note,
            editDisabled,
            deleteDisabled,
            deleteButtonPopover
        } = this.props;

        return (
            <div className={theme.note}>
                <Icon theme={theme} icon="note" className={theme.buttonIcon} />
                <EditableInputFieldWithDeleteButton
                    saveOnEnter={false}
                    rows={3}
                    theme={theme}
                    defaultIsActive={DataUtils.isEmpty(note)}
                    type="textarea"
                    value={note}
                    isEditingEnabled={!editDisabled}
                    onSave={this.saveNote}
                    onReject={this.onReject}
                    className={theme.noteField}
                    autoSaveOnChange={false}
                    onDelete={this.deleteNote}
                    editDisabled={editDisabled}
                    deleteDisabled={deleteDisabled}
                    disableEditIcon={editDisabled}
                    deleteButtonPopover={deleteButtonPopover}
                />
            </div>
        );
    }
}

const ThemedPlanNote = themr('PlanNote', defaultTheme)(PlanNote);

export { ThemedPlanNote as PlanNote };
export default ThemedPlanNote;
